const c = {
  "cdr-card": "cdr-card_14-1-1"
};
export {
  c as default
};
